import { useEffect, useState } from 'react';
import { onSnapshot, query, orderBy } from 'firebase/firestore';
import { participantsCol } from './participants';
import type { Participant } from './types';

export function useParticipants(tournamentId: string | undefined): {
  participants: Participant[] | undefined;
  error: Error | null;
} {
  const [participants, setParticipants] = useState<Participant[] | undefined>(undefined);
  const [error, setError] = useState<Error | null>(null);

  useEffect(() => {
    if (!tournamentId) {
      setParticipants([]);
      return;
    }
    const q = query(participantsCol(tournamentId), orderBy('displayName'));
    return onSnapshot(
      q,
      (snap) => setParticipants(snap.docs.map((d) => d.data())),
      (err) => setError(err)
    );
  }, [tournamentId]);

  return { participants, error };
}
